import { type FC } from 'react'
import { Button } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { EnrollmentLayout } from '@egw/layouts'
import { PageHeader } from '../../../components'

export const UnderReviewPage: FC = () => {
  const { t } = useTranslation('features-enrollment')

  const onSubmit = (): void => {
    window.location.href = 'https://www.evergreenmoney.com'
  }

  return (
    <EnrollmentLayout>
      <div className="egw-container h-full flex flex-col">
        {/* Body */}
        <div className="flex-1 flex flex-col justify-start md:justify-center">
          {/* Header */}
          <PageHeader title={t('generic.under_review.title')} />
          {/* Content */}
          <p className="typo-primary-base-regular text-text-body mb-md">{t('generic.under_review.paragraph_1')}</p>
          <p className="typo-primary-base-regular text-text-body">
            {t('generic.under_review.paragraph_2')} support@evergreen.money.
          </p>

          <div className="flex-1 md:hidden" />
          {/* Action */}
          <Button
            type="button"
            className="w-full md:w-min mt-lg"
            testId="enrollment-continue-button"
            onClick={onSubmit}
          >
            {t('generic.under_review.action')}
          </Button>
        </div>
      </div>
    </EnrollmentLayout>
  )
}
